import { UPDATED_RECEIPT_STATUS } from './Receipt';

const Subscription = {
  updatedReceiptStatus: UPDATED_RECEIPT_STATUS,
};

export { Subscription };
